/*
 * @Author: wangshengqiang
 * @Date: 2021-04-26 15:58:04
 * @LastEditTime: 2022-01-09 15:35:22
 * @LastEditors: wangshengqiang
 * @Description: 简单标题信息
 */
import React from 'react';
import { getLocalClick } from '@/components/EventBtn/handleEvent';
import './index.less';
export default function ProductTitle(props) {
  const {
    attrs
  } = props;
  const {
    showName = false,
    showRemark = false,
    showAlias = false,
    goodsName,
    goodsAlias,
    goodsRemark,
    events
  } = attrs;

  const onClick = () => {
    getLocalClick(events) && getLocalClick(events);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "c-product-plan-desc"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex"
  }, showName !== false ? /*#__PURE__*/React.createElement("div", {
    className: "product-plan-title"
  }, goodsName) : '', showAlias !== false ? /*#__PURE__*/React.createElement("div", {
    className: "product-plan-tag",
    onClick: onClick
  }, goodsAlias || '') : ''), showRemark !== false ? /*#__PURE__*/React.createElement("div", {
    className: "product-plan-desc"
  }, goodsRemark || '') : '');
}